import { render, staticRenderFns } from "./DownloadFile.vue?vue&type=template&id=dc21548e&scoped=true"
import script from "./DownloadFile.vue?vue&type=script&lang=js"
export * from "./DownloadFile.vue?vue&type=script&lang=js"
import style0 from "./DownloadFile.vue?vue&type=style&index=0&id=dc21548e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc21548e",
  null
  
)

export default component.exports